import type { AxiosInstance } from 'axios';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type { ServiceResult } from '../types/common/ServiceResult';
import type {
  NeighborhoodViewModel,
  NeighborhoodCreateModel,
  NeighborhoodUpdateModel,
} from '../types/neighborhood';
import { apiClient } from '../client/client';

export interface NeighborhoodQuery {
  districtId?: number | null;
}

export class NeighborhoodService {
  private static readonly BASE = '/api/neighborhood';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async getAll(query?: NeighborhoodQuery): Promise<ServiceResultT<NeighborhoodViewModel[]>> {
    const params: Record<string, number> = {};
    if (query?.districtId != null) params.DistrictId = query.districtId;
    const { data } = await this.client.get<ServiceResultT<NeighborhoodViewModel[]>>(
      NeighborhoodService.BASE,
      { params: Object.keys(params).length ? params : undefined }
    );
    return data;
  }

  async getById(id: number | string): Promise<ServiceResultT<NeighborhoodViewModel>> {
    const { data } = await this.client.get<ServiceResultT<NeighborhoodViewModel>>(
      `${NeighborhoodService.BASE}/${id}`
    );
    return data;
  }

  async create(payload: NeighborhoodCreateModel): Promise<ServiceResultT<NeighborhoodViewModel>> {
    const { data } = await this.client.post<ServiceResultT<NeighborhoodViewModel>>(
      NeighborhoodService.BASE,
      payload
    );
    return data;
  }

  async update(
    id: number | string,
    payload: NeighborhoodUpdateModel
  ): Promise<ServiceResultT<NeighborhoodViewModel>> {
    const { data } = await this.client.put<ServiceResultT<NeighborhoodViewModel>>(
      `${NeighborhoodService.BASE}/${id}`,
      payload
    );
    return data;
  }

  async delete(id: number | string): Promise<ServiceResult> {
    const { data } = await this.client.delete<ServiceResult>(`${NeighborhoodService.BASE}/${id}`);
    return data;
  }
}

export const neighborhoodService = new NeighborhoodService();
